import {
	classifyVaultRisk,
	formatCr,
	type ProtocolRiskParams,
	type VaultRiskMeta,
} from "@/lib/vault-risk";
import { cn } from "@/lib/utils";

export function VaultRiskBadge({
	collateralUsd,
	debtUsdm,
	className,
	size = "md",
	meta: metaProp,
	params,
	/** When false, only the status pill is shown (avoid duplicate CR/HF numbers in tables). */
	showFactor = true,
}: {
	collateralUsd?: number;
	debtUsdm?: number;
	className?: string;
	size?: "sm" | "md" | "lg";
	meta?: VaultRiskMeta;
	/** Live protocol risk params (min CR + liq threshold) */
	params?: Partial<ProtocolRiskParams> | null;
	showFactor?: boolean;
}) {
	const meta =
		metaProp ??
		classifyVaultRisk(collateralUsd ?? 0, debtUsdm ?? 0, params);

	const factorSize =
		size === "lg"
			? "text-xl sm:text-2xl"
			: size === "sm"
				? "text-sm"
				: "text-base sm:text-lg";

	return (
		<div
			className={cn(
				"flex flex-col items-end gap-1",
				!showFactor && "items-center",
				className,
			)}
			title={meta.hint}
		>
			<span
				className={cn(
					"inline-flex items-center rounded-full px-2.5 py-1 font-bold uppercase tracking-wide",
					size === "lg" ? "text-xs" : "text-[10px]",
					meta.badgeClass,
				)}
			>
				{meta.badge}
			</span>
			{showFactor ? (
				<span
					className={cn(
						"font-mono-amount font-bold tabular-nums leading-none",
						factorSize,
						meta.factorClass,
					)}
				>
					{formatCr(meta.cr)}
				</span>
			) : null}
		</div>
	);
}
